import type { CurrentUserTransformed } from "~pages/Users/types";
import type { CurrentUserDetailsResponse } from "~types/currentUserDetails.ts";
import transformUserPermission from "./transformUserPermission";

const transformCurrentUserDetailsResponse = (response: CurrentUserDetailsResponse): CurrentUserTransformed => {
  const user = response?.data[0];

  if (!user) {
    console.error("Current User Details response is empty");
    return {} as CurrentUserTransformed;
  }

  const resources = response?.includes?.resources || {};

  return {
    ...user,
    permissions: [
      ...user.userBasedPermissions.map((permission) => transformUserPermission(permission, false, resources)),
      ...user.roleBasedPermissions.map((permission) => transformUserPermission(permission, true, resources)),
    ],
    resources,
  };
};

export default transformCurrentUserDetailsResponse;
